import { render } from "./ViewPost.vue?vue&type=template&id=68f7bb5e"
import script from "./ViewPost.vue?vue&type=script&lang=js"
export * from "./ViewPost.vue?vue&type=script&lang=js"

import "./ViewPost.vue?vue&type=style&index=0&id=68f7bb5e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__